import React, { useEffect, useState } from "react"
import get from "lodash/get"
import { getAllRiskManagementSetting } from "store/riskManagement/actions"
import { useDispatch } from "react-redux"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Label,
  Input,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import { showErrorMessages, hasPermission } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { setAffiliateCall } from "helpers/repository"

export default function Affiliate(props) {
  const dispatch = useDispatch()

  const [cpa_amount, setCpaAmount] = useState("")
  const [revenue_share_percentage, setRevenueSharePercentage] = useState("")

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setCpaAmount(get(props, "data.cpa_amount", ""))
    setRevenueSharePercentage(get(props, "data.revenue_share_percentage", ""))
  }, [props.data])

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  const handleClick = () => {
    toggle()
  }

  const handleSubmit = e => {
    e.preventDefault()

    const data = {
      cpa_amount: Number(cpa_amount),
      revenue_share_percentage: Number(revenue_share_percentage),
    }

    setAffiliateCall(data)
      .then(function (response) {
        showMessage("success", response.data.message)
        dispatch(getAllRiskManagementSetting())
      })
      .catch(function (response) {
        showErrorMessages(response)
      })

    toggle()
  }

  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody>
            <CardTitle className="mb-4">Affiliate</CardTitle>

            <Form>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">CPA Amount</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.cpa_amount", "")}
                  </p>
                </Col>
              </div>

              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    Revenue Share Percentage
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.revenue_share_percentage", "")}%
                  </p>
                </Col>
              </div>

              {hasPermission("update-parameters") && (
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    type="button"
                    color="primary"
                    onClick={handleClick}
                  >
                    Edit
                  </Button>
                </div>
              )}
            </Form>
          </CardBody>
        </Card>
      </Col>

      <Modal centered isOpen={isOpen} toggle={toggle}>
        <ModalHeader tag="h4" toggle={toggle}>
          {"Update Affiliate"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <div className="mb-3">
              <Label htmlFor="cpa_amount_Input">CPA Amount</Label>
              <Input
                type="number"
                step="0.01"
                className="form-control"
                id="cpa_amount_Input"
                name={"cpa_amount"}
                value={cpa_amount}
                required
                onChange={e => {
                  setCpaAmount(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="revenue_share_percentage_Input">
                Revenue Share Percentage
              </Label>
              <Input
                type="number"
                step="0.01"
                className="form-control"
                id="revenue_share_percentage_Input"
                name={"revenue_share_percentage"}
                value={revenue_share_percentage}
                required
                onChange={e => {
                  setRevenueSharePercentage(e.target.value)
                }}
              />
            </div>

            <div className="text-end">
              <Button type="submit" className="btn btn-success w-md">
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}
